import axios from 'axios'
import APIConfig from '../remote/APIConfig.js'

export default class MessageService {
  constructor () {
    this.apis = {
      getAll: () => axios.get(APIConfig.BPIURL + '/message'),
      add: (payload) => axios.post(APIConfig.BPIURL + '/message', payload),
      edit: (id, payload) => axios.put(APIConfig.BPIURL + `/message/${id}`, payload),
      delete: (id) => axios.delete(APIConfig.BPIURL + `/message/${id}`)
    }
  }

  getAll (vm) {
    vm.isLoading = true
    return this.apis.getAll()
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        try {
          if (!ok) {
            vm.$services.alertResultError(vm, res)
          }
        } catch (err) {
          console.error(err)
        }
        return res
      })
      .catch(err => {
        vm.$services.alertError(vm, err)
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  add (vm, payload) {
    vm.isLoading = true
    return this.apis.add(payload)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        try {
          if (!ok) {
            vm.$services.alertResultError(vm, res)
          }
        } catch (err) {
          console.error(err)
        }
        return res
      })
      .catch(err => {
        vm.$services.alertError(vm, err)
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  edit (vm, payload) {
    vm.isLoading = true
    return this.apis.edit(payload.ID, payload)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        try {
          if (!ok) {
            vm.$services.alertResultError(vm, res)
          }
        } catch (err) {
          console.error(err)
        }
        return res
      })
      .catch(err => {
        vm.$services.alertError(vm, err)
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  delete (vm, id) {
    vm.isLoading = true
    return this.apis.delete(id)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        try {
          if (!ok) {
            vm.$services.alertResultError(vm, res)
          }
        } catch (err) {
          console.error(err)
        }
        return res
      })
      .catch(err => {
        vm.$services.alertError(vm, err)
      })
      .finally(() => {
        vm.isLoading = false
      })
  }
}
